import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/logo2.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "fixed inset-0 flex" }
const _hoisted_3 = { class: "absolute top-0 left-full flex w-16 justify-center pt-5" }
const _hoisted_4 = { class: "flex grow flex-col gap-y-5 overflow-y-auto px-6 pb-4 bg-white" }
const _hoisted_5 = { class: "flex flex-1 flex-col" }
const _hoisted_6 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_7 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "text-xs/6 font-semibold text-gray-400" }
const _hoisted_10 = {
  role: "list",
  class: "-mx-2 mt-2 space-y-1"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "truncate" }
const _hoisted_13 = {
  key: 1,
  class: "'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'"
}
const _hoisted_14 = { class: "border-gray-200 text-gray-400 flex size-6 shrink-0 items-center justify-center rounded-lg border text-[0.625rem] font-medium" }
const _hoisted_15 = { class: "truncate text-gray-400" }
const _hoisted_16 = { class: "mt-auto" }
const _hoisted_17 = ["href"]
const _hoisted_18 = {
  key: 1,
  class: "hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:w-72 lg:flex-col"
}
const _hoisted_19 = { class: "flex grow flex-col gap-y-5 overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4" }
const _hoisted_20 = { class: "flex flex-1 flex-col" }
const _hoisted_21 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-7"
}
const _hoisted_22 = {
  role: "list",
  class: "-mx-2 space-y-1"
}
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "text-xs/6 font-semibold text-gray-400" }
const _hoisted_25 = {
  role: "list",
  class: "-mx-2 mt-2 space-y-1"
}
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "truncate" }
const _hoisted_28 = {
  key: 1,
  class: "'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'"
}
const _hoisted_29 = { class: "border-gray-200 text-gray-400 flex size-6 shrink-0 items-center justify-center rounded-lg border text-[0.625rem] font-medium" }
const _hoisted_30 = { class: "truncate text-gray-400" }
const _hoisted_31 = { class: "mt-auto" }
const _hoisted_32 = ["href"]
const _hoisted_33 = { class: "bg-gray-100 sticky top-0 z-40 lg:mx-auto lg:max-w-7xl lg:px-8" }
const _hoisted_34 = { class: "flex h-16 items-center gap-x-4 border-b border-gray-200 px-4 shadow-xs sm:gap-x-6 sm:px-6 lg:px-0 lg:shadow-none" }
const _hoisted_35 = {
  key: 1,
  class: "h-6 w-px bg-gray-200 lg:hidden",
  "aria-hidden": "true"
}
const _hoisted_36 = { class: "flex flex-1 gap-x-4 self-stretch lg:gap-x-6 bg-gray-100" }
const _hoisted_37 = { class: "flex items-center gap-x-4 lg:gap-x-6" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "hidden lg:flex lg:items-center" }
const _hoisted_40 = {
  class: "ml-4 text-sm/6 font-semibold text-gray-900",
  "aria-hidden": "true"
}
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "py-4" }
const _hoisted_43 = { class: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" }
const _hoisted_44 = { class: "border-b border-gray-200 pb-5" }
const _hoisted_45 = { class: "font-semibold text-gray-900 text-xl" }
const _hoisted_46 = {
  key: 0,
  class: "mt-6"
}
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "mt-6" }
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { class: "mt-6" }
const _hoisted_51 = { key: 3 }
const _hoisted_52 = { class: "mt-6" }
const _hoisted_53 = { key: 4 }
const _hoisted_54 = { class: "mt-6" }
const _hoisted_55 = { key: 5 }
const _hoisted_56 = { class: "mt-6" }
const _hoisted_57 = { key: 6 }
const _hoisted_58 = { class: "mt-8" }
const _hoisted_59 = { class: "mt-8" }

import {
  ref, computed, onBeforeMount, onBeforeUnmount,
} from 'vue';
import { useRouter } from 'vue-router';
import useAuthStore from '@/store/auth';
import SimpleFooter from '@/components/tailwind/footer/SimpleFooter.vue';
import ListPluginReportsDashboard from '@/components/tailwind/plugin/ListPluginReportsDashboard.vue';
import PluginMetadatasMetrics from '@/components/tailwind/plugin/PluginMetadatasMetrics.vue';
import LivviaStrip from '@/components/tailwind/livvia/LivviaStrip.vue';
import ConnectEmpty from '@/components/tailwind/livvia/ConnectEmpty.vue';
import PrepareCards from '@/components/tailwind/livvia/PrepareCards.vue';
import LivesList from '@/components/tailwind/livvia/LivesList.vue';
import VideoPicker from '@/components/tailwind/livvia/VideoPicker.vue';
import LiveResult from '@/components/tailwind/livvia/LiveResult.vue';
import PluginConnectDrawer from '@/components/tailwind/plugin/PluginConnectDrawer.vue';
import useLivviaStore from '@/store/livvia';
import BlankProfilePicture from '@/assets/images/backgrounds/blank-profile-picture.png';
import {
  Dialog,
  DialogPanel,
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import {
  Bars3Icon,
  HeartIcon,
  PresentationChartBarIcon,
  Cog6ToothIcon,
  PuzzlePieceIcon,
  HomeIcon,
  XMarkIcon,
  CursorArrowRaysIcon,
} from '@heroicons/vue/24/outline';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import { useI18n } from 'vue-i18n';
import usePluginStore from '@/store/plugin/plugin';
import Plugin from '@/models/plugin/plugin';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardLayout',
  setup(__props) {

const router = useRouter();
const { session, authDoLogout } = useAuthStore();
const { t } = useI18n();
const {
  pluginsDoGetMy,
  pluginAnalyzeTranscription,
  pluginGetTranscriptionAnalysisStatus,
  pluginGetTranscriptionAnalysis,
  pluginSetLiveCartStatus,
  pluginUpdateSettings,
} = usePluginStore();
const livvia = useLivviaStore();

// Bind the plugin-store wrappers to Livvia's pipeline hook so the store
// stays framework-clean (no cross-store imports). Small adapters shim
// between the branch's method signatures and the PipelineAPI shape.
livvia.registerPipelineAPI({
  analyze: async ({ mediaId }) => {
    const r = await pluginAnalyzeTranscription(mediaId);
    return { status: (r as any)?.status || 'started' };
  },
  getStatus: async (mediaId) => {
    const r = await pluginGetTranscriptionAnalysisStatus(mediaId);
    return (r as any) || {};
  },
  getResult: pluginGetTranscriptionAnalysis,
  // TODO: wire aggregate to pluginGetAILiveShoppingCarts once we know the
  // accountId → InstagramLiveAIMetadataModel → CartLine mapping. Until
  // then, returning empty falls back to Livvia's demo mock so the flow
  // still walks end-to-end.
  aggregate: async () => ({ total_amount: 0, client_count: 0, carts: [] }),
  setCartStatus: async ({
    pluginId, mediaId, buyerUserId, status, reason,
  }) => pluginSetLiveCartStatus({
    pluginId, mediaId, buyerUserId, status, reason,
  }),
  updateSettings: async ({ pluginId, autoMessageEnabled }) => (
    pluginUpdateSettings({ pluginId, autoMessageEnabled })
  ),
});

/*
  Data
*/
const dataLoaded = ref(false);
const sidebarOpen = ref(false);
const plugins = ref([] as Plugin[]);

/*
  Methods
*/
// Preview hook — lets us walk the post-live flow in dev without a real
// pending live. Gated so it only works on local/staging builds; production
// builds ignore the param entirely.
const applyLivviaDevTrigger = (): boolean => {
  if (process.env.NODE_ENV === 'production') return false;
  const param = new URLSearchParams(window.location.search).get('livvia');
  if (param === 'post_live') {
    livvia.enterPostLive({
      durationLabel: '1h 42',
      commentsCount: 340,
      timestampLabel: t('livvia.postLive.mock.latestTitle'),
      platform: 'instagram',
    });
    return true;
  }
  return false;
};

const loadPlugins = async () => {
  await pluginsDoGetMy()
    .then((response) => {
      if (response !== undefined) {
        // Combine Instagram and Facebook plugins
        const allPlugins = [
          ...response.instagramPlugins.map((p: any) => new Plugin(p)),
          ...response.facebookPlugins.map((p: any) => new Plugin(p)),
        ].sort((a, b) => a.name.localeCompare(b.name));
        plugins.value = allPlugins;
      }
    }).catch((error) => {
      console.error('error', error);
    }).finally(() => {
      // Sellers with a single plugin have no "which one?" to make — their
      // dashboard IS that plugin's dashboard. Skip the multi-plugin overview
      // (and Livvia) and drop them straight in. Dev-trigger overrides so we
      // can still preview the multi-view + Livvia states.
      const igfbPlugins = plugins.value.filter(
        (p): p is typeof p & { type: 'instagram' | 'facebook' } => (
          p.type === 'instagram' || p.type === 'facebook'
        ),
      );
      const devTriggered = applyLivviaDevTrigger();
      // Single plugin → drop the seller straight into that plugin's
      // dashboard. Multiple plugins → send them to the manager so they
      // pick which one to work on. Zero plugins falls through to the
      // arrival/Livvia state below.
      if (!devTriggered && igfbPlugins.length === 1) {
        const only = igfbPlugins[0];
        router.replace({
          name: 'PluginDashboardPage',
          params: { pluginId: only.id, pluginType: only.type },
        });
        return;
      }
      if (!devTriggered && igfbPlugins.length > 1) {
        router.replace({ name: 'PluginsManagerPage' });
        return;
      }
      if (!devTriggered) {
        livvia.deriveFromPlugins(igfbPlugins.map((p) => ({
          id: p.id,
          type: p.type,
          pendingFullSyncMediaId: p.pendingFullSyncMediaId,
          lastSeenLive: p.lastSeenLive,
          autoMessageEnabled: p.autoMessageEnabled,
        })));
      }
      dataLoaded.value = true;
    });
};
const getProfileImageUrl = () => session?.profileImageUrl || BlankProfilePicture;
const logout = async () => {
  await authDoLogout().then(() => {
    window.open(router.resolve({ name: 'SessionLoginPage' }).href, '_self');
  }).catch((error) => {
    console.error(error);
    alert(t('session.logoutError'));
    // }).finally(() => {
    // window.location.reload();
  });
};

/*
  Computed
*/
const getUserFirstName = computed(() => session?.name.split(' ')[0]);
// Hide the whole sidebar (mobile drawer + desktop static column) while the
// seller has no plugin yet. Removes menu distractions during the very first
// integration; comes back the moment `deriveFromPlugins` sees a plugin.
const hideSidebar = computed(() => livvia.state === 'arrival');
const otherProducts = computed(() => [
  {
    id: 1, name: t('sidemenu.navigation.bio.title'), href: router.resolve({ name: 'UserBioManagerPage' }).href, initial: t('sidemenu.navigation.bio.initials'), current: false, disabled: false,
  },
  {
    id: 2, name: t('sidemenu.navigation.myBrand.title'), href: router.resolve({ name: 'MyMerchantsPage' }).href, initial: t('sidemenu.navigation.myBrand.initials'), current: false, disabled: false,
  },
]);
const userNavigation = computed(() => [
  { name: t('sidemenu.navigation.profile.title'), href: router.resolve({ name: 'UserProfileManagerPage' }).href, method: null },
  { name: t('plugins.manager.title'), href: router.resolve({ name: 'PluginsManagerPage' }).href, method: null },
  { name: t('sidemenu.navigation.bio.title'), href: router.resolve({ name: 'UserBioManagerPage' }).href, method: null },
  // { name: t('sidemenu.navigation.signout.title'), href: '#', method: logout },
]);
const navigation = computed(() => [
  {
    name: t('sidemenu.navigation.dashboard.title'), href: router.resolve({ name: 'DashboardPage' }).href, icon: HomeIcon, current: true,
  },
  {
    name: t('sidemenu.navigation.integration.title'), href: router.resolve({ name: 'PluginsManagerPage' }).href, icon: PuzzlePieceIcon, current: false,
  },
  {
    name: t('sidemenu.navigation.crm.title'), href: router.resolve({ name: 'CRMDashboardPage' }).href, icon: CursorArrowRaysIcon, current: false,
  },
  {
    name: t('sidemenu.navigation.shared-report.title'), href: router.resolve({ name: 'PluginLivesSharedWithMePage' }).href, icon: PresentationChartBarIcon, current: false,
  },
  {
    name: t('sidemenu.navigation.affiliate-panel.title'), href: router.resolve({ name: 'AffiliateDashboardPage' }).href, icon: HeartIcon, current: false,
  },
]);

/*
  Hooks
*/
onBeforeMount(() => {
  loadPlugins();
});

// Kill any in-flight processing timers if the user navigates away
// mid-flow so state doesn't mutate after the component is gone.
onBeforeUnmount(() => {
  livvia.cancelProcessing();
});

return (_ctx: any,_cache: any) => {
  return (dataLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!hideSidebar.value)
          ? (_openBlock(), _createBlock(_unref(TransitionRoot), {
              key: 0,
              as: "template",
              show: sidebarOpen.value
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Dialog), {
                  class: "relative z-50 lg:hidden",
                  onClose: _cache[1] || (_cache[1] = ($event: any) => (sidebarOpen.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(TransitionChild), {
                      as: "template",
                      enter: "transition-opacity ease-linear duration-300",
                      "enter-from": "opacity-0",
                      "enter-to": "opacity-100",
                      leave: "transition-opacity ease-linear duration-300",
                      "leave-from": "opacity-100",
                      "leave-to": "opacity-0"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createElementVNode("div", { class: "fixed inset-0 bg-gray-900/80" }, null, -1)
                      ])),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_unref(TransitionChild), {
                        as: "template",
                        enter: "transition ease-in-out duration-300 transform",
                        "enter-from": "-translate-x-full",
                        "enter-to": "translate-x-0",
                        leave: "transition ease-in-out duration-300 transform",
                        "leave-from": "translate-x-0",
                        "leave-to": "-translate-x-full"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(DialogPanel), { class: "relative mr-16 flex w-full max-w-xs flex-1" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(TransitionChild), {
                                as: "template",
                                enter: "ease-in-out duration-300",
                                "enter-from": "opacity-0",
                                "enter-to": "opacity-100",
                                leave: "ease-in-out duration-300",
                                "leave-from": "opacity-100",
                                "leave-to": "opacity-0"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "-m-2.5 p-2.5",
                                      onClick: _cache[0] || (_cache[0] = ($event: any) => (sidebarOpen.value = false))
                                    }, [
                                      _cache[5] || (_cache[5] = _createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)),
                                      _createVNode(_unref(XMarkIcon), {
                                        class: "size-6 text-white",
                                        "aria-hidden": "true"
                                      })
                                    ])
                                  ])
                                ]),
                                _: 1
                              }),
                              _createElementVNode("div", _hoisted_4, [
                                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex h-16 shrink-0 items-center" }, [
                                  _createElementVNode("img", {
                                    class: "h-8 w-auto",
                                    src: _imports_0,
                                    alt: "LiveLink LLM"
                                  })
                                ], -1)),
                                _createElementVNode("nav", _hoisted_5, [
                                  _createElementVNode("ul", _hoisted_6, [
                                    _createElementVNode("li", null, [
                                      _createElementVNode("ul", _hoisted_7, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: item.name
                                          }, [
                                            _createElementVNode("a", {
                                              href: item.href,
                                              class: _normalizeClass([item.current ? 'bg-gray-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50 hover:text-teal-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
                                            }, [
                                              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                                class: _normalizeClass([item.current ? 'text-teal-600' : 'text-gray-400 group-hover:text-teal-600', 'size-6 shrink-0']),
                                                "aria-hidden": "true"
                                              }, null, 8, ["class"])),
                                              _createTextVNode(" " + _toDisplayString(item.name), 1)
                                            ], 10, _hoisted_8)
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("li", null, [
                                      _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(t)('sidemenu.products.title')), 1),
                                      _createElementVNode("ul", _hoisted_10, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherProducts.value, (product) => {
                                          return (_openBlock(), _createElementBlock("li", {
                                            key: product.name
                                          }, [
                                            (!product.disabled)
                                              ? (_openBlock(), _createElementBlock("a", {
                                                  key: 0,
                                                  href: product.href,
                                                  class: _normalizeClass([product.current ? 'bg-gray-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50 hover:text-teal-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
                                                }, [
                                                  _createElementVNode("span", {
                                                    class: _normalizeClass([product.current ? 'border-teal-600 text-teal-600' : 'border-gray-200 text-gray-400 group-hover:border-teal-600 group-hover:text-teal-600', 'flex size-6 shrink-0 items-center justify-center rounded-lg border text-[0.625rem] font-medium'])
                                                  }, _toDisplayString(product.initial), 3),
                                                  _createElementVNode("span", _hoisted_12, _toDisplayString(product.name), 1)
                                                ], 10, _hoisted_11))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                                  _createElementVNode("span", _hoisted_14, _toDisplayString(product.initial), 1),
                                                  _createElementVNode("span", _hoisted_15, _toDisplayString(product.name), 1)
                                                ]))
                                          ]))
                                        }), 128))
                                      ])
                                    ]),
                                    _createElementVNode("li", _hoisted_16, [
                                      _createElementVNode("a", {
                                        href: _unref(router).resolve({ name: 'UserProfileManagerPage' }).href,
                                        class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-700 hover:bg-gray-50 hover:text-teal-600"
                                      }, [
                                        _createVNode(_unref(Cog6ToothIcon), {
                                          class: "size-6 shrink-0 text-gray-400 group-hover:text-teal-600",
                                          "aria-hidden": "true"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(_unref(t)('sidemenu.navigation.settings.title')), 1)
                                      ], 8, _hoisted_17)
                                    ])
                                  ]),
                                  _createVNode(SimpleFooter, {
                                    horizontal: false,
                                    "no-backgound": true
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["show"]))
          : _createCommentVNode("", true),
        (!hideSidebar.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex h-16 shrink-0 items-center" }, [
                  _createElementVNode("img", {
                    class: "h-8 w-auto",
                    src: _imports_0,
                    alt: "Your Company"
                  })
                ], -1)),
                _createElementVNode("nav", _hoisted_20, [
                  _createElementVNode("ul", _hoisted_21, [
                    _createElementVNode("li", null, [
                      _createElementVNode("ul", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navigation.value, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.name
                          }, [
                            _createElementVNode("a", {
                              href: item.href,
                              class: _normalizeClass([item.current ? 'bg-gray-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50 hover:text-teal-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
                            }, [
                              (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                                class: _normalizeClass([item.current ? 'text-teal-600' : 'text-gray-400 group-hover:text-teal-600', 'size-6 shrink-0']),
                                "aria-hidden": "true"
                              }, null, 8, ["class"])),
                              _createTextVNode(" " + _toDisplayString(item.name), 1)
                            ], 10, _hoisted_23)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('sidemenu.navigation.grow-with-us.title')), 1),
                      _createElementVNode("ul", _hoisted_25, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(otherProducts.value, (product) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: product.name
                          }, [
                            (!product.disabled)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: product.href,
                                  class: _normalizeClass([product.current ? 'bg-gray-50 text-teal-600' : 'text-gray-700 hover:bg-gray-50 hover:text-teal-600', 'group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold'])
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([product.current ? 'border-teal-600 text-teal-600' : 'border-gray-200 text-gray-400 group-hover:border-teal-600 group-hover:text-teal-600', 'flex size-6 shrink-0 items-center justify-center rounded-lg border text-[0.625rem] font-medium'])
                                  }, _toDisplayString(product.initial), 3),
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(product.name), 1)
                                ], 10, _hoisted_26))
                              : (_openBlock(), _createElementBlock("p", _hoisted_28, [
                                  _createElementVNode("span", _hoisted_29, _toDisplayString(product.initial), 1),
                                  _createElementVNode("span", _hoisted_30, _toDisplayString(product.name), 1)
                                ]))
                          ]))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_31, [
                      _createElementVNode("a", {
                        href: _unref(router).resolve({ name: 'UserProfileManagerPage' }).href,
                        class: "group -mx-2 flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold text-gray-700 hover:bg-gray-50 hover:text-teal-600"
                      }, [
                        _createVNode(_unref(Cog6ToothIcon), {
                          class: "size-6 shrink-0 text-gray-400 group-hover:text-teal-600",
                          "aria-hidden": "true"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('sidemenu.navigation.settings.title')), 1)
                      ], 8, _hoisted_32)
                    ])
                  ]),
                  _createVNode(SimpleFooter, {
                    horizontal: false,
                    "no-backgound": true,
                    "hide-label": true
                  })
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(hideSidebar.value ? '' : 'lg:pl-72')
        }, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              (!hideSidebar.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "-m-2.5 p-2.5 text-gray-700 lg:hidden",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (sidebarOpen.value = true))
                  }, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sr-only" }, "Open sidebar", -1)),
                    _createVNode(_unref(Bars3Icon), {
                      class: "size-6",
                      "aria-hidden": "true"
                    })
                  ]))
                : _createCommentVNode("", true),
              (!hideSidebar.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_36, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "grid flex-1 grid-cols-1" }, null, -1)),
                _createElementVNode("div", _hoisted_37, [
                  _cache[11] || (_cache[11] = _createElementVNode("div", {
                    class: "hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200",
                    "aria-hidden": "true"
                  }, null, -1)),
                  _createVNode(_unref(Menu), {
                    as: "div",
                    class: "relative"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MenuButton), { class: "-m-1.5 flex items-center p-1.5" }, {
                        default: _withCtx(() => [
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "sr-only" }, "Open user menu", -1)),
                          _createElementVNode("img", {
                            class: "size-8 rounded-full bg-gray-50",
                            src: getProfileImageUrl(),
                            alt: ""
                          }, null, 8, _hoisted_38),
                          _createElementVNode("span", _hoisted_39, [
                            _createElementVNode("span", _hoisted_40, _toDisplayString(getUserFirstName.value), 1),
                            _createVNode(_unref(ChevronDownIcon), {
                              class: "ml-2 size-5 text-gray-400",
                              "aria-hidden": "true"
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_Transition, {
                        "enter-active-class": "transition ease-out duration-100",
                        "enter-from-class": "transform opacity-0 scale-95",
                        "enter-to-class": "transform opacity-100 scale-100",
                        "leave-active-class": "transition ease-in duration-75",
                        "leave-from-class": "transform opacity-100 scale-100",
                        "leave-to-class": "transform opacity-0 scale-95"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MenuItems), { class: "bg-white absolute right-0 z-10 mt-2.5 w-48 origin-top-right rounded-md py-2 ring-1 shadow-lg ring-gray-900/5 focus:outline-hidden" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userNavigation.value, (item) => {
                                return (_openBlock(), _createBlock(_unref(MenuItem), {
                                  key: item.name
                                }, {
                                  default: _withCtx(({ active }) => [
                                    _createElementVNode("a", {
                                      href: item.href,
                                      class: _normalizeClass([active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900'])
                                    }, _toDisplayString(item.name), 11, _hoisted_41)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "my-1 border-t border-gray-100" }, null, -1)),
                              _createVNode(_unref(MenuItem), null, {
                                default: _withCtx(({ active }) => [
                                  _createElementVNode("a", {
                                    href: "#",
                                    class: _normalizeClass([active ? 'bg-gray-50 outline-hidden' : '', 'block px-3 py-1 text-sm/6 text-gray-900']),
                                    onClick: logout
                                  }, _toDisplayString(_unref(t)('sidemenu.navigation.signout.title')), 3)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]),
          _createElementVNode("main", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("h3", _hoisted_45, _toDisplayString(_unref(t)('dashboard.title', {name: getUserFirstName.value})), 1)
              ]),
              (_unref(livvia).isVisible)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createVNode(LivviaStrip)
                  ]))
                : _createCommentVNode("", true),
              (_unref(livvia).state === 'arrival')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createVNode(ConnectEmpty)
                    ])
                  ]))
                : (_unref(livvia).state === 'prepare' || _unref(livvia).state === 'prepare_success')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createVNode(PrepareCards)
                      ])
                    ]))
                  : (_unref(livvia).state === 'post_live' || _unref(livvia).state === 'post_live_deferred')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createVNode(LivesList)
                        ])
                      ]))
                    : (_unref(livvia).state === 'video_picker' || _unref(livvia).state === 'processing')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(VideoPicker)
                          ])
                        ]))
                      : (_unref(livvia).state === 'result')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _createElementVNode("div", _hoisted_56, [
                              _createVNode(LiveResult)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(PluginMetadatasMetrics)
                            ]),
                            _createElementVNode("div", _hoisted_59, [
                              _createVNode(ListPluginReportsDashboard, { plugins: plugins.value }, null, 8, ["plugins"])
                            ])
                          ]))
            ])
          ]),
          _createVNode(PluginConnectDrawer, {
            show: _unref(livvia).showConnectDrawer,
            "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_unref(livvia).showConnectDrawer) = $event)),
            platform: _unref(livvia).connectPlatform || undefined
          }, null, 8, ["show", "platform"])
        ], 2)
      ]))
    : _createCommentVNode("", true)
}
}

})